export default "__VITE_ASSET__9lGCbEqv__"